import React from "react";
import { Form, Input, Row, Col } from "antd";
import { User } from "../../../types/admin/UserTypes";

interface CompanyTabProps {
	updatedUser: User;
	setUpdatedUser: React.Dispatch<React.SetStateAction<any>>;
	handleAutoSave: () => void;
}

const CompanyTab: React.FC<CompanyTabProps> = ({ updatedUser, setUpdatedUser, handleAutoSave }) => {
	const handleChange = (field: string, value: any) => {
		setUpdatedUser((prev: any) => ({ ...prev, [field]: value }));
	};

	return (
		<Form layout="vertical">
			<Row gutter={[16, 0]}>
				<Col xs={24} md={12}>
					<Form.Item label="Panel Key">
						<Input
							value={updatedUser.panel_key || ""}
							onChange={(e) => handleChange("panel_key", e.target.value)}
							onBlur={handleAutoSave}
							placeholder="Enter panel key"
						/>
					</Form.Item>
				</Col>
				<Col xs={24} md={12}>
					<Form.Item label="Reagents">
						<Input
							value={updatedUser.reagents || ""}
							onChange={(e) => handleChange("reagents", e.target.value)}
							onBlur={handleAutoSave}
							placeholder="Enter reagents"
						/>
					</Form.Item>
				</Col>
			</Row>
		</Form>
	);
};

export default CompanyTab;
